const AssignmentsEmptyState = ({ isParent = false }) => (
    <section className="assignments-empty-state">
        <p className="eyebrow">Assignments</p>
        <h2>No assignments yet 📚</h2>
        <p>
            {isParent
                ? "Assign your first reading challenge to help kids begin their reading journey."
                : "Assign your first reading challenge to help students begin their reading journey."}
        </p>
    </section>
);

export default AssignmentsEmptyState;
